(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["advent-launch-countdown"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('advent-countdown')) {
    customElements.define(
      'advent-countdown',
      class AdventCountdown extends HTMLElement {
        connectedCallback() {
          this.target = Date.parse(this.dataset.target);
          this.countdown = this.querySelector('[data-countdown]');
          this.dateLabel = this.querySelector('[data-countdown-date]');
          this.available = this.querySelector('[data-available]');
          this.status = this.querySelector('[data-countdown-status]');
          this.lastAnnouncedMinute = null;

          if (Number.isNaN(this.target)) return;

          this.update();
          this.interval = window.setInterval(() => this.update(), 1000);
        }

        disconnectedCallback() {
          window.clearInterval(this.interval);
        }

        update() {
          const remaining = Math.max(0, this.target - Date.now());

          if (remaining === 0) {
            window.clearInterval(this.interval);
            const reveal = () => {
              this.countdown.hidden = true;
              this.dateLabel.hidden = true;
              this.available.hidden = false;
              this.status.textContent = this.dataset.liveMessage;
            };

            if (document.startViewTransition) {
              document.startViewTransition(reveal);
            } else {
              reveal();
            }
            return;
          }

          const totalSeconds = Math.floor(remaining / 1000);
          const days = Math.floor(totalSeconds / 86400);
          const hours = Math.floor((totalSeconds % 86400) / 3600);
          const minutes = Math.floor((totalSeconds % 3600) / 60);
          const seconds = totalSeconds % 60;

          this.querySelector('[data-days]').textContent = String(days).padStart(2, '0');
          this.querySelector('[data-hours]').textContent = String(hours).padStart(2, '0');
          this.querySelector('[data-minutes]').textContent = String(minutes).padStart(2, '0');
          this.querySelector('[data-seconds]').textContent = String(seconds).padStart(2, '0');

          const totalMinutes = Math.ceil(remaining / 60000);
          if (totalMinutes !== this.lastAnnouncedMinute) {
            this.lastAnnouncedMinute = totalMinutes;
            this.status.textContent = [
              days,
              this.querySelector('[data-days] + span').textContent,
              hours,
              this.querySelector('[data-hours] + span').textContent,
              minutes,
              this.querySelector('[data-minutes] + span').textContent
            ].join(' ');
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
